import React from "react";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import Medisend from "../../components/screen/sinkronisasi/Medisend";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";

const SyncMedisendPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Sinkronisasi Medisend"
        mainComponent={
          <ThemeProvider theme={theme}>
            <Medisend />
          </ThemeProvider>
        }
        pageRole={45}
      />
    </div>
  );
};

export default SyncMedisendPage;
